/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5df174787f0bfc986bbaa386b2ea562807e300e3";
